"use strict";
/*
  A copy of server utility functions for casual gameplay,
  that doesn't require server.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var BoardManager_1 = require("./board/BoardManager");
var BoardState_1 = require("./board/BoardState");
var GameConstants_1 = require("./GameConstants");
var GameVars_1 = require("./GameVars");
var LocalServer = /** @class */ (function () {
    function LocalServer() {
    }
    LocalServer.init = function () {
        console.log("Initing localServer");
        this.setData();
    };
    LocalServer.setData = function () {
        this.cards = [];
        this.pilesData = [];
        this.time = 300;
        this.timeout = null;
        this.score = 0;
        this.moves = 0;
    };
    LocalServer.getDeck = function (seed, currentInstance) {
        // console.warn("Getting deck");
        var rand = seed % 500;
        if (!this.decks) {
            this.decks = currentInstance.game.cache.getJSON("LevelData").decks;
        }
        this.cards = JSON.parse(this.decks[rand]);
        this.pilesData = this.setPilesData(this.cards);
        BoardManager_1.BoardManager.currentInstance.initialCards({ cards: this.cards, pilesData: this.pilesData });
    };
    LocalServer.startTimer = function () {
        // console.warn("starting timer");
        this.timeout = setInterval(function () {
            if (!GameVars_1.GameVars.paused)
                LocalServer.time--;
            GameVars_1.GameVars.time = LocalServer.time;
            if (LocalServer.time === 0) {
                BoardManager_1.BoardManager.currentInstance.showWinner(GameConstants_1.GameConstants.FINAL_TIME);
            }
            if (LocalServer.time === 0) {
                clearInterval(LocalServer.timeout);
            }
        }, 1000);
    };
    LocalServer.ResetTimer = function () {
        clearInterval(LocalServer.timeout);
    };
    LocalServer.nextCard = function () {
        // console.warn("Next card", this.pilesData[12].cards.length);
        if (this.pilesData[12].cards.length) {
            var card = this.pilesData[12].cards.shift();
            this.pilesData[12].flipped--;
            this.pilesData[11].cards.push(card);
        }
        var data = {
            pilesData: this.pilesData, score: this.score,
            moves: this.moves
        };
        this.onServerCards(data);
    };
    LocalServer.endGame = function (gameStatus) {
        // console.warn("End game");
        clearInterval(this.timeout);
        if (gameStatus) {
            // console.log("End game due to => ", gameStatus);
        }
        if (gameStatus === 0) {
            // console.log("Adding bonus => ", this.time);
            // adding time bonus
            this.score += this.time;
        }
    };
    LocalServer.moveCardClient = function (data) {
        // console.warn("move card client");
        var value = this.applyMoveCard(this.pilesData, data, this.score, this.moves);
        this.score = value.score;
        this.moves = value.moves;
        // console.log("Move card", this.score);
        var serverData = { pilesData: this.pilesData, score: this.score, moves: this.moves, autocomplete: data.autocomplete };
        this.onServerCards(serverData);
    };
    LocalServer.moveCardsClient = function () {
        // console.warn("move cards client");
        if (this.pilesData[12].cards.length === 0) {
            while (this.pilesData[11].cards.length !== 0) {
                var card = this.pilesData[11].cards.shift();
                this.pilesData[12].cards.push(card);
            }
        }
        this.pilesData[12].flipped = this.pilesData[12].cards.length;
        if (this.pilesData[12] && this.pilesData[12].flipped > 0) {
            this.score = Math.max(0, this.score - 200);
            // console.log("moveCardsClient score",  this.score);
        }
        // console.log("Move cards", this.score);
        var serverData = { pilesData: this.pilesData, score: this.score, moves: this.moves };
        this.onServerCards(serverData);
    };
    LocalServer.onServerCards = function (data) {
        GameVars_1.GameVars.points = data.score;
        GameVars_1.GameVars.moves = data.moves;
        // console.log("on server cards", data);
        BoardManager_1.BoardManager.currentInstance.hideWaitingServer();
        if (data.autocomplete && GameVars_1.GameVars.gameEnded === GameConstants_1.GameConstants.NO_FINAL) {
            setTimeout(function () {
                if (GameVars_1.GameVars.gameEnded === GameConstants_1.GameConstants.NO_FINAL) {
                    BoardManager_1.BoardManager.currentInstance.autoCompleteGame();
                    BoardManager_1.BoardManager.currentInstance.checks(!data.autocomplete);
                    BoardState_1.BoardState.currentInstance.hud.updatePoints();
                    BoardState_1.BoardState.currentInstance.hud.updateMoves();
                }
            }, 200);
        }
        else {
            BoardManager_1.BoardManager.currentInstance.checks(!data.autocomplete);
            BoardState_1.BoardState.currentInstance.hud.updatePoints();
            BoardState_1.BoardState.currentInstance.hud.updateMoves();
        }
    };
    LocalServer.setPilesData = function (cards) {
        var count = 0;
        var pilesData = [];
        // foundation piles
        for (var i = 0; i < 4; i++) {
            var pileData_1 = { cards: [], flipped: 0 };
            pilesData.push(pileData_1);
        }
        // piles
        for (var i = 0; i < 7; i++) {
            var pileData_2 = { cards: [], flipped: 0 };
            for (var j = 0; j < 7; j++) {
                if (j <= i) {
                    pileData_2.cards.push(cards[count]);
                    count++;
                }
            }
            pileData_2.flipped = i;
            pilesData.push(pileData_2);
        }
        pilesData.push({ cards: [], flipped: 0 });
        var pileData = { cards: [], flipped: 0 };
        for (var i = count; i < cards.length; i++) {
            pileData.cards.push(cards[i]);
        }
        pileData.flipped = pileData.cards.length;
        pilesData.push(pileData);
        return pilesData;
    };
    LocalServer.applyMoveCard = function (pilesData, data, score, moves) {
        // data: card, prevPile, newPile
        var card = data.card;
        var prevPile = data.prevPile;
        var newPile = data.newPile;
        if (newPile.foundation) {
            var prevTopCard = pilesData[prevPile.column].cards[pilesData[prevPile.column].cards.length - 1];
            if (prevTopCard.value === card.value && prevTopCard.suit === card.suit) {
                if (pilesData[newPile.column].cards.length === 0) {
                    if (card.value === 1) {
                        score += this.moveCard(pilesData, prevPile, newPile, card);
                        moves++;
                        if (!prevPile.foundation) {
                            score += 100;
                        }
                    }
                }
                else {
                    var topCard = pilesData[newPile.column].cards[pilesData[newPile.column].cards.length - 1];
                    if (card.suit === topCard.suit && card.value - 1 === topCard.value) {
                        score += this.moveCard(pilesData, prevPile, newPile, card);
                        moves++;
                        if (!prevPile.foundation) {
                            score += 100;
                        }
                    }
                }
            }
        }
        else {
            if (pilesData[newPile.column].cards.length) {
                var topCard = pilesData[newPile.column].cards[pilesData[newPile.column].cards.length - 1];
                if (card.suit === 1 || card.suit === 3) {
                    if (topCard.suit === 0 || topCard.suit === 2) {
                        if (card.value + 1 === topCard.value) {
                            score += this.moveCard(pilesData, prevPile, newPile, card);
                            moves++;
                            if (prevPile.foundation) {
                                score -= 100;
                            }
                        }
                    }
                }
                else {
                    if (topCard.suit === 1 || topCard.suit === 3) {
                        if (card.value + 1 === topCard.value) {
                            score += this.moveCard(pilesData, prevPile, newPile, card);
                            moves++;
                            if (prevPile.foundation) {
                                score -= 100;
                            }
                        }
                    }
                }
            }
            else {
                if (card.value === 13) {
                    score += this.moveCard(pilesData, prevPile, newPile, card);
                    moves++;
                    if (prevPile.foundation) {
                        score -= 100;
                    }
                }
            }
        }
        return { moves: moves, score: score };
    };
    LocalServer.moveCard = function (pilesData, prevPile, newPile, card) {
        var count = 1;
        var score = prevPile.column === 11 ? 50 : 0;
        for (var i = pilesData[prevPile.column].cards.length - 1; i >= 0; i--) {
            if (pilesData[prevPile.column].cards[i].value === card.value && pilesData[prevPile.column].cards[i].suit === card.suit) {
                break;
            }
            else {
                count++;
            }
        }
        var cards = pilesData[prevPile.column].cards.splice(pilesData[prevPile.column].cards.length - count, count);
        pilesData[newPile.column].cards = pilesData[newPile.column].cards.concat(cards);
        if (pilesData[prevPile.column].flipped === pilesData[prevPile.column].cards.length && pilesData[prevPile.column].flipped > 0) {
            pilesData[prevPile.column].flipped--;
            score += 50;
        }
        return score;
    };
    LocalServer.pilesData = [];
    LocalServer.cards = [];
    LocalServer.time = 300;
    LocalServer.score = 0;
    LocalServer.moves = 0;
    LocalServer.decks = undefined;
    return LocalServer;
}());
exports.LocalServer = LocalServer;
